"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _FormControlLabel = _interopRequireDefault(require("@material-ui/core/FormControlLabel"));
var _Radio = _interopRequireDefault(require("@material-ui/core/Radio"));
var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));
var _clsx = _interopRequireDefault(require("clsx"));
var _styles = _interopRequireDefault(require("./styles"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var RadioCard = props => {
  var {
    value,
    active,
    Icon,
    displayText
  } = props;
  var classes = (0, _styles.default)(props);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes.radioCardContainer
  }, /*#__PURE__*/_react.default.createElement(_FormControlLabel.default, {
    value: value,
    control: /*#__PURE__*/_react.default.createElement(_Radio.default, {
      color: "primary"
    }),
    className: (0, _clsx.default)(classes.radioCard, active && classes.activeRadioCard),
    label: /*#__PURE__*/_react.default.createElement("div", {
      className: classes.paymentOptionContainer
    }, /*#__PURE__*/_react.default.createElement(Icon, {
      className: (0, _clsx.default)(classes.paymentIcon, active && classes.blueText)
    }), /*#__PURE__*/_react.default.createElement(_Typography.default, {
      className: active ? classes.blueText : null
    }, displayText))
  }));
};
var _default = exports.default = RadioCard;